// extracted by mini-css-extract-plugin
export var footer = "_pm-0";
export var inherit = "_pm-1";
export var input = "_pm-2";
export var modalContent = "_pm-3";
export var quillEditor = "_pm-4";
export var subtitle = "_pm-5";